module.exports = __webpack_public_path__ + "static/holiday-inn-geelong-2dd6571981005d60338e3b18e69dbaae.jpg";